import { jsx } from "react/jsx-runtime";
import { FlexBox } from "../flexBox/FlexBox.js";
import { theme } from "../../theme/index.js";
const coverGapVariable = "--cover-gap";
const Cover = ({ children, minHeight = '100vh', gap = '300', padding = gap, className, style, ...flexBoxProps })=>/*#__PURE__*/ jsx(FlexBox, {
        className: className,
        style: {
            ...style,
            minHeight,
            [coverGapVariable]: theme.spacing[gap],
            padding: theme.spacing[padding]
        },
        ...flexBoxProps,
        flexDirection: "column",
        children: children
    });
const Header = ({ children, style, ...flexboxProps })=>/*#__PURE__*/ jsx(FlexBox, {
        style: {
            ...style,
            marginTop: 0,
            marginBottom: `var(${coverGapVariable})`
        },
        flexDirection: "column",
        ...flexboxProps,
        children: children
    });
const Center = ({ children, style, ...flexboxProps })=>/*#__PURE__*/ jsx(FlexBox, {
        style: {
            ...style,
            marginTop: 'auto',
            marginBottom: 'auto'
        },
        flexDirection: "column",
        ...flexboxProps,
        children: children
    });
const Footer = ({ children, style, ...flexboxProps })=>/*#__PURE__*/ jsx(FlexBox, {
        style: {
            ...style,
            marginTop: `var(${coverGapVariable})`,
            marginBottom: 0
        },
        flexDirection: "column",
        ...flexboxProps,
        children: children
    });
Cover.Header = Header;
Cover.Header.displayName = 'Cover.Header';
Cover.Center = Center;
Cover.Center.displayName = 'Cover.Center';
Cover.Footer = Footer;
Cover.Footer.displayName = 'Cover.Footer';
export { Cover };
